export const PreQualifierAssetTypeDetailsDialogUat = {
  title: 'preQualifierAssetTypeDetailsDialog.title',
  description: 'preQualifierAssetTypeDetailsDialog.description',
  confirmButton: 'preQualifierAssetTypeDetailsDialog.confirmButton',
  cancelButton: 'preQualifierAssetTypeDetailsDialog.cancelButton',
}
